export default __webpack_public_path__ + "fapvoer-64bd86.jpg";